import React, { useState } from "react";
import { AddContainer } from "./style";
import { CloseableArea } from "../../../../components/closeableArea";
import { withRouter } from "react-router-dom";

import { Link } from "react-router-dom";

export const Add = props => {
  const [active, setActive] = useState(false);
  return (
    <AddContainer
      status={active}
      hasShadow={props.hasShadow}
      expand={props.expand}
    >
      <Link className={`add-button`} title="ثبت اطلاعات" to="/create-data">
          <div className="button-text" >
            <i className="icon mapsa-plus"> </i>
            <span className="add-button-text no-select">ثبت اطلاعات</span>
          </div>

      </Link>
    </AddContainer>
  );
};
